import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { removeSnackbar } from './../../actions/common.action'

let displayed = []
let displayedMessages = new Set()

const Notifier = () => {
  const dispatch = useDispatch()
  const notifications = useSelector(store => store.common.notifications || []) || [];
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const storeDisplayed = (id, message) => {
    displayed = [...displayed, id]
    if (message) displayedMessages.add(message)
  }

  const removeDisplayed = (id, message) => {
    displayed = [...displayed.filter(key => id !== key)]
    if (message) displayedMessages.delete(message)
  }

  React.useEffect(() => {
    if (!Array.isArray(notifications)) return;
    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      if (dismissed) {
        // dismiss snackbar using notistack
        closeSnackbar(key)
        return
      }

      // do nothing if snackbar is already displayed or identical message is currently active
      if (displayed.includes(key) || (message && displayedMessages.has(message))) {
        if (!displayed.includes(key)) {
          dispatch(removeSnackbar(key))
        }
        return
      }

      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey)
          }
        },
        onExited: (event, myKey) => {
          // removen this snackbar from redux store
          dispatch(removeSnackbar(myKey))
          removeDisplayed(myKey, message)
        }
      })

      // keep track of snackbars that we've displayed
      storeDisplayed(key, message)
    })
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch])

  return null
}

export default Notifier
